import React from "react";
import WhyDriveUnique from "../../../WhyDriveUnique/WhyDriveUnique";
import "./NammaDriverWhyDriveUDriverService.css"


function NammaDriverWhyDriveUDriverService() {
  return (
    <>
      <div className="CallDriversWhyDriveU_Main_div">
        <div className="CallDriversWhyDriveU_Heading_div">
          Why Choose DriveU
        </div>
        <div className="CallDriversWhyDriveU_SubHeading_div">
          While there maybe other players in the market like Ezi Drive and
          Top4CallDriver, here's what makes DriveU unique.
        </div>
      </div>

      <WhyDriveUnique styleProps={"styleChange"} />
    </>
  );
}

export default NammaDriverWhyDriveUDriverService;